import React, {useEffect, useState} from 'react'
import garbageIcon from '../../../../../../assets/editors/garbage_icon.svg';
import {

    EVENT_TYPE_FLYER_PAGE_CONTROLS_SELECT_ALL_SPOTS,
    EVENT_TYPE_FLYER_PAGE_CONTROLS_UNSELECT_ALL_SPOTS,
    EVENT_TYPE_FLYER_PAGE_CONTROLS_DELETE_SPOTS,

    EVENT_TYPE_SPOTS_UNSELECT_ONE_OR_MORE_SPOTS,
    EVENT_TYPE_SPOTS_SELECT_ONE_OR_MORE_SPOTS,
    EVENT_TYPE_SPOTS_ALL_SPOTS_SELECTED_WITH_CTRL_A,
    EVENT_TYPE_SPOTS_NO_SPOTS_SELECTED,

    // EVENT_TYPE_PAGE_INDEX_CHANGED,

    dispatchEventType,
    removeEventTypeListener,
    addEventTypeListener, addEventDataTypeListener,
} from '../../../../../../globals/EventDispatcher'

import './FlyerPageControls.scss'
import {useTypedSelector} from "../../../../../../hooks/useTypeSelector";
import {useDispatch} from "react-redux";
import {toggleSelectAllMode} from "../../../../../../store/actionCreators/spotsActionCreators";
import {FlyerPageSpotDto, UserDto} from "../../../../../../dtos";
import {makeStyles} from "@mui/styles";
import {Box, Button, Checkbox, FormControlLabel} from "@mui/material";
import ZoomInOut from "./zoomInOut";

const useStyles = makeStyles(() => ({
    pagesControls: {
        display: "flex",
        alignItems: "center",
        flexFlow: "row",
        columnGap: "4px",
        padding: "0 12px 0 0",
    },
    checkboxWithLabelWrapper: {
        display: "flex",
        alignItems: "center",
        flexFlow: "row",
        "& > .MuiTypography-root": {
            width: "80px",
            lineHeight: 1,
            fontSize: "14px",
            fontWeight: "700",
            paddingTop: "2px"
        }
    },
    trashIcon: {
        "&.MuiButton-root": {
            width: "20px",
            height: "20px",
            "&:disabled": {
                opacity: "0.4"
            }
        }
    }
}))

interface IFlyerPageControls {
    // selectAllPageSpots: (value: boolean) => void
    // deleteAllPageSpots: () => void
    setZoomStatus: any;
    pageIndex: number;
    selectedFrames?: FlyerPageSpotDto[];
    framesOnPage: FlyerPageSpotDto[];
}

// class properties methods
export const FlyerPageControls: React.FC<IFlyerPageControls> = (props) => {
    const dispatch = useDispatch();
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    let {spots} = useTypedSelector((state) => state);
    const classes = useStyles();
    // const [isAllChecked, setIsAllChecked] = useState(false)
    //
    // const getNAme = () => {
    //     return "name"
    // }

    // const keyboardManager = useRef<KeyboardManager | null>(null);
    // if(keyboardManager.current === null){
    //     keyboardManager.current = KeyboardManager.getInstance();
    //     keyboardManager.current.addEventListener(KeyboardManager.CTRL_A, () => {

    //         if(isAllChecked){
    //             props.selectAllPageSpots(isAllChecked)
    //         }
    //         setIsAllChecked(true)
    //     })
    // }

    // useEffect(() => {
    //     // props.selectAllPageSpots(isAllChecked)
    // }, [isAllChecked])

    const [garbageIconClass, setGarbageIconClass] = useState('garbadge_icon_disable');

    let userDtoStr = localStorage.getItem('userDto');
    // const isUserViewer = false;
    let isUserViewer = true;
    if(userDtoStr){
        let userDto: UserDto = JSON.parse(userDtoStr);
        isUserViewer = userDto.role !== 2 && userDto.role !== 3;
    }

    useEffect(() => {
        if (spots.isSelectAll) {
            dispatchEventType(EVENT_TYPE_FLYER_PAGE_CONTROLS_SELECT_ALL_SPOTS);
        } else {
            dispatchEventType(EVENT_TYPE_FLYER_PAGE_CONTROLS_UNSELECT_ALL_SPOTS);
        }

    }, [spots.isSelectAll]);

    useEffect(() => {
        if (props.selectedFrames?.length) {
            setGarbadgeIconEnabled(true);
        } else {
            setGarbadgeIconEnabled(false);
        }
    }, [props.selectedFrames]);

    useEffect(() => {
        if (props.framesOnPage.length === 0) {
            dispatch(toggleSelectAllMode(false));
        }
    }, [props.framesOnPage]);

    useEffect(() => {

        addEventTypeListener(EVENT_TYPE_SPOTS_ALL_SPOTS_SELECTED_WITH_CTRL_A, () => {
            // props.selectAllPageSpots(true)
            // setIsAllChecked(true)
            dispatch(toggleSelectAllMode(true));
            setGarbadgeIconEnabled(true);
        })

        addEventTypeListener(EVENT_TYPE_SPOTS_UNSELECT_ONE_OR_MORE_SPOTS, () => {
            // props.selectAllPageSpots(true)
            dispatch(toggleSelectAllMode(false));
            // setIsAllChecked(false)
            setGarbadgeIconEnabled(true);
        })

        addEventTypeListener(EVENT_TYPE_SPOTS_NO_SPOTS_SELECTED, () => {
            // setIsAllChecked(false);
            dispatch(toggleSelectAllMode(false));
            setGarbadgeIconEnabled(false);
        })

        addEventDataTypeListener(EVENT_TYPE_SPOTS_SELECT_ONE_OR_MORE_SPOTS, (data) => {
            dispatch(toggleSelectAllMode(data.data));
            setGarbadgeIconEnabled(true);
        })

        // addEventTypeListener(EVENT_TYPE_PAGE_INDEX_CHANGED, () => {
        //     // since we are changing page => we need to disable the checkbox etc.
        //     spots.isSelectAll ?
        //         dispatchEventType(EVENT_TYPE_FLYER_PAGE_CONTROLS_SELECT_ALL_SPOTS) :
        //         dispatchEventType(EVENT_TYPE_FLYER_PAGE_CONTROLS_UNSELECT_ALL_SPOTS);
        // });


        return () => {
            removeEventTypeListener(EVENT_TYPE_SPOTS_ALL_SPOTS_SELECTED_WITH_CTRL_A)
            removeEventTypeListener(EVENT_TYPE_SPOTS_UNSELECT_ONE_OR_MORE_SPOTS)
            removeEventTypeListener(EVENT_TYPE_SPOTS_NO_SPOTS_SELECTED)
            removeEventTypeListener(EVENT_TYPE_SPOTS_SELECT_ONE_OR_MORE_SPOTS)
            // removeEventTypeListener(EVENT_TYPE_PAGE_INDEX_CHANGED)
            // component will unmount
            // if(keyboardManager.current) {
            //     keyboardManager.current.dispose();
            // }

        }
    }, [])

    const setGarbadgeIconEnabled = (value: boolean) => {
        if (value) {
            setGarbageIconClass('')
        } else {
            setGarbageIconClass('garbadge_icon_disable')
        }
    }

    return (
        <div className={classes.pagesControls}>

            {/*<div className="col flyer_page_controls_left_controls">*/}

            {/*</div>*/}

            {/*<div className="col flyer_page_controls_center_controls">*/}

            {/*</div>*/}
            <FormControlLabel
                className={classes.checkboxWithLabelWrapper}
                sx={{margin: `0`}}
                control={
                    <Checkbox
                        disableRipple disableTouchRipple
                        inputProps={{'aria-label': 'controlled'}}
                        size={'small'}
                        sx={{
                            padding: `0`,
                            marginRight: `5px`
                        }}
                        checked={spots.isSelectAll}
                        disabled={flyerDetailsState.flyFstRec.fstCaption === "Published"}
                        onChange={() => {
                            let newState = !spots.isSelectAll;
                            // console.log(props.pageIndex);
                            dispatch(toggleSelectAllMode(newState));
                            newState ?
                                dispatchEventType(EVENT_TYPE_FLYER_PAGE_CONTROLS_SELECT_ALL_SPOTS) :
                                dispatchEventType(EVENT_TYPE_FLYER_PAGE_CONTROLS_UNSELECT_ALL_SPOTS)
                        }}
                    />

                }
                label={spots.isSelectAll ? `Deselect All` : `Select All`}
            />
            <Button
                className={classes.trashIcon}
                disableRipple
                disabled={garbageIconClass === "garbadge_icon_disable" || isUserViewer}
                onClick={() => {
                    // if(!isAllChecked) {
                    //     return;
                    // }
                    dispatchEventType(EVENT_TYPE_FLYER_PAGE_CONTROLS_DELETE_SPOTS)
                    // setIsAllChecked(false)
                }}
            >
                <img
                    src={garbageIcon}
                    alt=""
                />
            </Button>
            <Box
                sx={{
                    marginLeft: "36px"
                }}
            >
                <ZoomInOut/>
            </Box>
        </div>
    )
}